import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_PAGEACTION_TYPE, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/itemGroupEntrySlice";


const ItemGroupMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")

    // Fetch shape data
    const {
        data,
        isPending,
        isError,
        mutate: filterData
    } = usePost({
        url: apiRoute.itemGroup.fetch,
        queryKey: "fetchItemGroupMaster",
    });

    const funLoadData = () => {
        filterData({
            data: {}
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])


    const onSuccessDelete = () => {
        setItemToDelete("")
        funLoadData()
    };

    // Delete shape mutation
    const { mutate: fnDelete } = usePost({
        url: apiRoute.itemGroup.deleteEntry,
        queryKey: "deletegroupMaster",
        onSuccessTasks: onSuccessDelete,
        //successMessage: "Item Group deleted successfully!",
    });

    const exportColumns = [
        {
            name: "GROUP CODE",
            uid: "Itgr_Code",
        },
        {
            name: "GROUP NAME",
            uid: "Itgr_Name",
        },
        {
            name: "St Per",
            uid: "StPer",
        },
        {
            name: "Ast Per",
            uid: "AstPer",
        },
        {
            name: "Cst Per",
            uid: "CstPer",
        },


    ]

    let downloadDataFooter = {
        Itgr_Code: "",
        Itgr_Name: "",
        StPer: "",
        AstPer: "",
        CstPer: ""
    }

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete && itemToDelete != null)
                fnDelete({ data: { itgr_code: itemToDelete } });
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                dispatch(setDetailParams(itemToEdit));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.master.itemGroup.createItemGroupMaster);
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.master.itemGroup.createItemGroupMaster);
    };



    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Group Code", uid: "Itgr_Code", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Group Name", uid: "Itgr_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "St Per", uid: "StPer", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Ast Per", uid: "AstPer", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Cst Per", uid: "CstPer", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    itgr_code: row.Itgr_Code
                };
                setItemToEdit(obj)
                // dispatch(setDetailParams(obj));
                // dispatch(setNewEntryMode(false))
                // navigate(linksUrl.master.itemGroup.createItemGroupMaster);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete(row.Itgr_Code)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Item Group" breadcrumbs={["Mater", "Item Group Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "Itgr_Name", "StPer", "AstPer", "CstPer"]}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="ItemGroup-master-List"
                    id="Itgr_Code"

                />
            </MainContainer>


            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
        </div>
    );
};

export default ItemGroupMaster;
